module.exports = __webpack_public_path__ + "media/1_3-37.1ad5fdc7.mp3";